import dayjs, { Dayjs } from 'dayjs';
import { BUTTON_STYLES, Button, RadioInput } from '~/ui';
import styles from './XlsReportFeedbacksPopoverContent.module.scss';
import { useContext, useState } from 'react';
import { PopoverContext } from '~/components/XlsUploadFilePopover/XlsUploadFilePopover';
import { downloadReportFile } from '~/utils/downloadReportFile';
import { useDebounce } from '@uidotdev/usehooks';
import { useTranslation } from 'react-i18next';
import CustomQuerySelect from '~/components/Shared/CustomQuerySelect/CustomQuerySelect';
import { CustomDatePicker } from '~/components/Shared/CustomDatePicker/CustomDatePicker';

interface IAccommodation {
  id: number;
  name: string;
}

const XlsReportFeedbacksPopoverContent = () => {
  const [startDate, setStartDate] = useState<Dayjs | null>(null);
  const [endDate, setEndDate] = useState<Dayjs | null>(null);
  const [accommodations, setAccommodations] = useState<IAccommodation[]>([]);
  const [typeReport, setTypeReport] = useState('1');
  const debouncedSearchTerm = useDebounce('', 500);
  const { setIsPopoverVisible } = useContext(PopoverContext);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isAllAccommodationChecked, setIsAllAccommodationChecked] =
    useState<boolean>(false);
  const { t } = useTranslation();

  const params = {
    sort: '',
    perPage: 100,
    field: '',
    query: debouncedSearchTerm,
    page: 1,
  };

  const onClosePopup = () => {
    setStartDate(null);
    setEndDate(null);
    setIsPopoverVisible(false);
    setAccommodations([]);
  };

  const downloadFileReport = async () => {
    setIsLoading(true);
    let typeReportPath: string;
    let typeReportName: string;

    if (!isAllAccommodationChecked) {
      typeReportPath = `/analytics-feedback-accommodation-date${
        accommodations.length
          ? `?accommodation_ids[]=${accommodations
              .map(accommodation => accommodation.id)
              .join('&accommodation_ids[]=')}`
          : ''
      }`;
      typeReportName = 'analytics-accommodation-feedback';

      await downloadReportFile(
        typeReportPath,
        typeReportName,
        startDate,
        endDate
      );
      setIsLoading(false);
    } else {
      typeReportPath = '/analytics-feedback-accommodation-date';
      typeReportName = 'analytics-accommodation-feedback';

      await downloadReportFile(
        typeReportPath,
        typeReportName,
        startDate,
        endDate,
        true
      );
      setIsLoading(false);
    }
  };

  const disabledSendReport =
    !startDate ||
    !endDate ||
    (!isAllAccommodationChecked && !accommodations.length);

  const disabledDate = (current: Dayjs) => {
    return current && current > dayjs().endOf('day');
  };

  return (
    <div className={styles.formWrapper}>
      <span className={styles.formTitle}>{t('feedback_analytics')}</span>
      <div className={styles.radioBtnTypeReportWrapper}>
        <RadioInput
          label={t('accommodations_report')}
          name="type_report"
          value="1"
          onChange={() => setTypeReport('1')}
          checkValue={typeReport}
          disabled={false}
        />
      </div>
      <CustomQuerySelect
        label={t('object')}
        query="admin/accommodations"
        queryKey={['accommodations', params]}
        placeholder={t('accommodations_validate')}
        params={params}
        value={accommodations}
        onChange={value => {
          if (Array.isArray(value)) {
            setAccommodations(value);
          }
        }}
        required
        disabled={isAllAccommodationChecked}
        multiselect
        isSearchEnabled
        hasCheckbox
        checkboxLabel={t('all_accommodation_selection')}
        setIsCheckedAll={value => setIsAllAccommodationChecked(value)}
      />
      <div className={styles.dateWrapper}>
        <div className={styles.labelWrapper}>
          <span className={styles.labelText}>
            {t('date')}
            <span className={styles.labelStar}>*</span>
          </span>
          <CustomDatePicker
            value={[startDate, endDate]}
            showPresets={true}
            placeholder={[t('date_from'), t('date_by')]}
            disabledDate={disabledDate}
            onChange={(name, value) => {
              if (name === 'start_date') {
                setStartDate(value);
              } else if (name === 'end_date') {
                setEndDate(value);
              }
            }}
          />
        </div>
      </div>
      <div className={styles.btnWrapper}>
        <Button
          onClick={onClosePopup}
          className={styles.contentBtn}
          text={t('cancel')}
          disabled={false}
          buttonStyle={BUTTON_STYLES.EMPTY}
        />
        <Button
          onClick={downloadFileReport}
          type="submit"
          text={t('download_report')}
          className={styles.sendBtn}
          disabled={disabledSendReport || isLoading}
          isLoading={isLoading}
        />
      </div>
    </div>
  );
};

export default XlsReportFeedbacksPopoverContent;
